import { theme } from 'antd';
const { useToken } = theme;

const DryerIcon = ({
  color,
  width = 22,
  height = 22,
  ...rest
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorIcon;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 22"
      fill="none"
      style={{ flexShrink: 0 }}
      {...rest}
    >
      <path
        d="M4.5 0.000488281C5.82683 0.0131735 7.01307 0.294338 7.83398 0.555176C8.56244 0.78674 9 1.48609 9 2.25049V5.00537H12V2.22803C12 1.47737 12.4219 0.788251 13.1348 0.553223C13.9567 0.282317 15.1561 -0.00845346 16.5 0.00439453C17.8268 0.0170797 19.0131 0.298245 19.834 0.559082C20.5624 0.790646 21 1.49 21 2.25439V15.9351C21 16.6032 20.6603 17.2266 20.0312 17.4517C19.4495 17.6597 18.6055 17.8777 17.5 17.9644V21.5044C17.5 21.7805 17.2761 22.0044 17 22.0044H16.5205C16.5137 22.0047 16.5069 22.0063 16.5 22.0063H4.51855C4.51238 22.0066 4.50623 22.0083 4.5 22.0083H3.5C3.22392 22.0083 3.00011 21.7844 3 21.5083V17.9097C2.13806 17.804 1.46114 17.6227 0.970703 17.4478C0.340578 17.2229 0 16.5983 0 15.9292V2.22412C0 1.47347 0.421867 0.784345 1.13477 0.549316C1.95669 0.278411 3.15609 -0.0123597 4.5 0.000488281ZM9 15.9312C9 16.5993 8.66032 17.2227 8.03125 17.4478C7.36476 17.6861 6.35407 17.9377 5 17.9888V20.0063H15.5V17.9634C14.3959 17.8761 13.5523 17.6591 12.9707 17.4517C12.3406 17.2268 12 16.6022 12 15.9331V11.0054H9V15.9312Z"
        fill={currentColor}
      />
    </svg>
  );
};

export default DryerIcon;

